import { Reveal } from '../../../components/Reveal.jsx'
import { LOGOS } from '../constants/photos.js'
import { WELCOME_OFFER_URL } from '../constants/links.js'

export function FinalCTA() {
  return (
    <section
      className="py-[clamp(64px,8vw,88px)] text-center text-white max-[640px]:py-14"
      style={{ background: 'linear-gradient(135deg,#721A55,#020000)' }}
    >
      <div className="hb-wrap">
        <Reveal>
          <div>
            <img
              src={LOGOS.monoWhite}
              alt=""
              width={150}
              height={103}
              loading="lazy"
              className="mx-auto mb-5 h-auto w-[78px] opacity-90"
            />
            <p className="font-display text-[12px] font-extrabold uppercase tracking-[2.5px] text-sprout/80">
              For Our IV On Call Family
            </p>
            <h2 className="mx-auto mt-4 max-w-[640px] font-serif text-[clamp(32px,4.2vw,44px)] font-semibold leading-[1.1] tracking-[-0.5px] text-white">
              Already a patient at IV On Call?
              <br />
              Welcome home.
            </h2>
            <p className="mx-auto mt-4 max-w-[520px] text-[16px] leading-[1.7] text-white/82 sm:text-[18px]">
              &ldquo;HealBerry is the next chapter — built by the same team you already trust, with
              expanded protocols designed around your whole health picture.&rdquo;
            </p>
            <a
              href={WELCOME_OFFER_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-white btn-lg mt-8"
            >
              Access Your HealBerry Welcome Offer
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  )
}
